const initialState = { 
  loading: true,
  payload: null,
  error: null
}

function detailProductReducer(state = initialState, action) {
  switch (action.type) {
    case 'DETAIL_PRODUCT_BEGIN':
      return {
        ...state,
        loading: true,
        error: null
      }

    case 'DETAIL_PRODUCT_SUCCESS':
      return {
        ...state,
        loading: false,
        payload: action.payload
      }

    case 'DETAIL_PRODUCT_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: return state
  }
}

export default detailProductReducer